import styled from "styled-components";
import { SideBlock } from "../../styles/Delivery.styles";
import { ScrollableWrapper } from "../SideAddons/SideAddonsInfo/SideAddonsInfo.styles";
import SummaryBlock from "./SummaryBlock";

export const Summary = styled(SummaryBlock)`
  ${ScrollableWrapper} {
    &::after {
      background-image: linear-gradient(
        to bottom,
        ${({ theme }) => theme.fadeMaskTransparent},
        ${({ theme }) => theme.surface}
      );
    }
  }

  ${SideBlock} {
    width: 100%;
    padding: 10px 20px 0;

    ${(props) => props.theme.xs`
      padding: 0;
    `}
  }

  .ReactCollapse--content > ${SideBlock}:first-of-type {
    border: none;
  }
`;
